import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { SortableContainer } from "react-sortable-hoc";
import TableHeader from "./TableHeader";
import TableBody from "./TableBody";
import Pagination from "./Pagination";
import { createPortal } from "react-dom";
import { isSet } from "../../../utils/commonUtils";
import HeaderButtons from "../HeaderButtons";
import NewTableHeader from "../NewTableGrid/NewTableHeader";
import NewTableBody from "../NewTableGrid/NewTableBody";
import NewPagination from "../NewTableGrid/NewPagination";

const TableGrid = (props) => {
  const [tableFooter, setTableFooter] = useState(null);
  const tableRef = useRef(null);

  // ✅ Get from Redux
  const isNewUI = useSelector((state) => state.common.isNewUI);

  useEffect(() => {
    if (tableRef.current && tableFooter == null) {
      const paginationTargetContainer = tableRef.current.closest(".sh_cardBox");
      setTableFooter(paginationTargetContainer);
    }
  }, []);

  return (
    <>
      {isNewUI ? (
        <TableGridHOC hasHeaderAction={props.hasHeaderAction} isNewUI={isNewUI} needCardBody={props.needCardBody}> 
          {/* Header Buttons */}
          {props.hasHeaderAction === true && (
            <HeaderButtons {...props.headersProps} />
          )}
          <table
            {...props.tableHandler}
            className={`table dataTable sh_tablenew nowrap${
              props.hover ? "table-hover" : ""
            } ${props.customClass}`}
            width="100%"
            cellSpacing="0"
            ref={tableRef}
            style={{ width: "100%" }}
          >
            <NewTableHeader {...props} />
            <NewTableBody {...props} />
          </table>

          {props.hasPagination === true ? (
            isSet(tableFooter, null) !== null ? (
              <div className="">
                {createPortal(
                  <NewPagination tableRef={tableRef} {...props} />,
                  tableFooter
                )}
              </div>
            ) : (
              <></>
            )
          ) : (
            ""
          )}
        </TableGridHOC>
      ) : (
        <TableGridHOC hasHeaderAction={props.hasHeaderAction} isNewUI={isNewUI}>
          {/* Header Buttons */}
          {props.hasHeaderAction === true && (
            <HeaderButtons {...props.headersProps} />
          )}
          <table
            {...props.tableHandler}
            className={`table dataTable nowrap my-0 ${
              props.hover ? "table-hover" : ""
            } ${props.customClass}`}
            width="100%"
            cellSpacing="0"
            ref={tableRef}
            style={{ width: "100%" }}
          >
            <TableHeader {...props} />
            <TableBody {...props} />
          </table>

          {props.hasPagination === true ? (
            isSet(tableFooter, null) !== null ? (
              <div className="">
                {createPortal(
                  <Pagination tableRef={tableRef} {...props} />,
                  tableFooter
                )}
              </div>
            ) : (
              <></>
            )
          ) : (
            ""
          )}
        </TableGridHOC>
      )}
    </>
  );
};

TableGrid.defaultProps = {
  hasHeaderAction: false,
  className: "table",
  width: "100%",
  style: {},
  additionalAttr: {},
  tableHandler: {},
  hover: true,
  customClass: "",
  needCardBody:true
};

// ✅ TableGridHOC updated — now uses isNewUI
const TableGridHOC = ({ hasHeaderAction, isNewUI, children,needCardBody }) => {
  if (hasHeaderAction === false) {
    return children;
  }

  return (
    <div
      className={
        isNewUI
          ? `${needCardBody ? "sh_cardBody " : ""}p-0 sh_cardBody sh_cardbglight`
          : "sh_cardBody p-0"
      }
    >
      {children}
    </div>
  );
};

const SortableCont = SortableContainer(({ children }) => {
  return children;
});

export default TableGrid;
